module.exports = __webpack_public_path__ + "static/media/master_card.c9e36090.png";